export const getRecursiveChildren = row => {
  let children = [];

  row.forEach(item => {
    if (item.row) {
      children = [...children, ...getRecursiveChildren(item.row)];
    } else if (item.child) {
      children.push(item.child);
    }
  });

  return children;
};

export const getInitialValues = (characteristic, data) => {
  const initialValues = {};

  const onlyChildrenArr = getRecursiveChildren(characteristic);
  onlyChildrenArr.forEach(({ type, name, path }) => {
    switch (type) {
      case 'totalSurface':
      case 'coveredSurface':
      case 'uncoveredSurface':
      case 'semiCoveredSurface':
      case 'exclusiveSurface':
        if (!initialValues.surface) initialValues.surface = {};
        initialValues.surface[type] = data.surface
          ? data.surface[type] || ''
          : '';
        break;

      case 'antiquity':
        if (!initialValues.antiquity) initialValues.antiquity = {};
        const dataAntiquity = data.antiquity || {};
        initialValues.antiquity = {
          years: dataAntiquity.years || '',
          type: dataAntiquity.type || ''
        };
        break;

      case 'price':
      case 'expenses':
        if (!initialValues.price) initialValues.price = {};
        const dataPrice = data.price || {};

        if (type === 'price') {
          initialValues.price = {
            ...initialValues.price,
            total: dataPrice.total || '',
            currency: dataPrice.currency || 1
          };
        } else {
          initialValues.price = {
            ...initialValues.price,
            expenses: dataPrice.expenses || '',
            expensesCurrency: dataPrice.expensesCurrency || 1
          };
        }
        break;

      case 'switch':
      case 'checkbox':
        if (path.includes('characteristics')) {
          if (!initialValues.characteristics)
            initialValues.characteristics = {};
          initialValues.characteristics[name] = data.characteristics
            ? data.characteristics[name] || false
            : false;
        } else {
          if (!initialValues.ambiences_types)
            initialValues.ambiences_types = {};
          initialValues.ambiences_types[name] = data.ambiences_types
            ? data.ambiences_types[name] || false
            : false;
        }
        break;

      case 'laundry':
      case 'balcony':
      case 'yard':
      case 'rooftop':
        if (!initialValues.characteristics) initialValues.characteristics = {};
        initialValues.characteristics[type] = data.characteristics
          ? data.characteristics[type] || { active: false, type: '' }
          : { active: false, type: '' };
        break;

      case 'garages':
        if (!initialValues.characteristics) initialValues.characteristics = {};
        initialValues.characteristics[type] = data.characteristics
          ? data.characteristics[type] || {
              active: false,
              cover: '',
              ubication: '',
              quantity: ''
            }
          : {
              active: false,
              cover: '',
              ubication: '',
              quantity: ''
            };
        break;

      case 'minusPlus':
        if (!initialValues.characteristics) initialValues.characteristics = {};
        initialValues.characteristics[name] = data.characteristics
          ? data.characteristics[name] || 0
          : 0;
        break;
      case 'buildingStage':
        if (!initialValues.characteristics) initialValues.characteristics = {};
        initialValues.characteristics[type] = data.characteristics
          ? data.characteristics[type] || ''
          : '';
        break;
      case 'buildingLocationInBlock':
        if (!initialValues.characteristics) initialValues.characteristics = {};
        initialValues.characteristics[type] = data.characteristics
          ? data.characteristics[type] || ''
          : '';
        break;
      case 'buildingCeilingHeight':
        if (!initialValues.characteristics) initialValues.characteristics = {};
        initialValues.characteristics[type] = data.characteristics
          ? data.characteristics[type] || ''
          : '';
        break;
      case 'buildingAntiquity':
        if (!initialValues.characteristics) initialValues.characteristics = {};
        initialValues.characteristics[type] = data.characteristics
          ? data.characteristics[type] || ''
          : '';
        break;
      case 'buildingCategory':
        if (!initialValues.characteristics) initialValues.characteristics = {};
        initialValues.characteristics[type] = data.characteristics
          ? data.characteristics[type] || ''
          : '';
        break;
      case 'buildingBrightness':
        if (!initialValues.characteristics) initialValues.characteristics = {};
        initialValues.characteristics[type] = data.characteristics
          ? data.characteristics[type] || ''
          : '';
        break;
      case 'buildingDisposition':
        if (!initialValues.characteristics) initialValues.characteristics = {};
        initialValues.characteristics[type] = data.characteristics
          ? data.characteristics[type] || ''
          : '';
        break;
      case 'buildingState':
        if (!initialValues.characteristics) initialValues.characteristics = {};
        initialValues.characteristics[type] = data.characteristics
          ? data.characteristics[type] || ''
          : '';
        break;
      case 'buildingOrientation':
        if (!initialValues.characteristics) initialValues.characteristics = {};
        initialValues.characteristics[type] = data.characteristics
          ? data.characteristics[type] || ''
          : '';
        break;
      case 'buildingType':
        if (!initialValues.characteristics) initialValues.characteristics = {};
        initialValues.characteristics[type] = data.characteristics
          ? data.characteristics[type] || ''
          : '';
        break;
      case 'description':
        initialValues.description = data.description || '';
        break;
    }
  });
  return initialValues;
};
